export const keysEn = {
  list: [
    {
      type: '1',
      line: [
        {
          letter: '1',
        },
        {
          letter: '2',
        },
        {
          letter: '3',
        },
        {
          letter: '4',
        },
        {
          letter: '5',
        },
        {
          letter: '6',
        },
        {
          letter: '7',
        },
        {
          letter: '8',
        },
        {
          letter: '9',
        },
        {
          letter: '0',
        },
        {
          letter: '-',
        },
        {
          letter: 'bksp',
          type: 'bksp',
          className: 'keyboard__button_bksp',
        },
      ],
    },

    {
      type: '1',
      line: [
        {
          letter: 'q',
          className: 'keyboard__button_start-2-en',
        },
        {
          letter: 'w',
        },
        {
          letter: 'e',
        },
        {
          letter: 'r',
        },
        {
          letter: 't',
        },
        {
          letter: 'y',
        },
        {
          letter: 'u',
        },
        {
          letter: 'i',
        },
        {
          letter: 'o',
        },
        {
          letter: 'p',
          className: 'keyboard__button_prev-enter',
        },
      ],
    },

    {
      type: '1',
      line: [
        {
          className: 'keyboard__button_start-3-en',
          letter: 'a',
        },
        {
          letter: 's',
        },
        {
          letter: 'd',
        },
        {
          letter: 'f',
        },
        {
          letter: 'g',
        },
        {
          letter: 'h',
        },
        {
          letter: 'j',
        },
        {
          letter: 'k',
        },
        {
          letter: 'l',
        },
        {
          letter: "''",
        },
        {
          letter: '_',
        },
      ],
    },

    {
      type: '1',
      line: [
        {
          className: 'keyboard__button_start-4-en',
          letter: 'z',
        },
        {
          letter: 'x',
        },
        {
          letter: 'c',
        },
        {
          letter: 'v',
        },
        {
          letter: 'b',
        },
        {
          letter: 'n',
        },
        {
          letter: 'm',
        },
        {
          letter: ',',
        },
        {
          letter: '.',
        },
        {
          letter: '/',
        },
        {
          letter: '@',
        },
      ],
    },
  ],
};
